import { render, staticRenderFns } from "./HeadlineBox.vue?vue&type=template&id=5e92d8ed&scoped=true"
import script from "./HeadlineBox.vue?vue&type=script&lang=js"
export * from "./HeadlineBox.vue?vue&type=script&lang=js"
import style0 from "./HeadlineBox.vue?vue&type=style&index=0&id=5e92d8ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e92d8ed",
  null
  
)

export default component.exports